import { WISE_ALIAS } from './provider-constants';
function isWiseAlias(alias) {
    return alias === WISE_ALIAS;
}
export { isWiseAlias };
